import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../config";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";

const UserPermissionEditPage = () => {
  const { permissionId } = useParams(); // Get the permission ID from the URL
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    permission_name: "",
    description: "",
  });
  const [loading, setLoading] = useState(true);

  // Fetch permission data on component mount
  useEffect(() => {
    const fetchPermission = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/admin/permissions/${permissionId}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("authentication/token")}` },
        });
        setFormData({
          permission_name: response.data.permission_name,
          description: response.data.description,
        });
      } catch (error) {
        console.error("Error fetching permission:", error);
        Swal.fire("Error!", "Failed to fetch permission data.", "error");
        navigate("/permissions");
      } finally {
        setLoading(false);
      }
    };

    fetchPermission();
  }, [permissionId, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${BASE_URL}/admin/permissions/${permissionId}`, formData, {
        headers: { Authorization: `Bearer ${localStorage.getItem("authentication/token")}` },
      });
      Swal.fire("Success!", "Permission updated successfully.", "success");
      navigate("/permissions");
    } catch (error) {
      console.error("Error updating permission:", error);
      Swal.fire("Error!", "Failed to update permission.", "error");
    }
  };

  if (loading) {
    return <div className="text-center py-4">Loading...</div>;
  }

  return (
    <div className="bg-white shadow-md rounded-lg p-4">
      <h2 className="text-lg font-semibold mb-4">Edit Permission</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Permission Name</label>
          <input
            type="text"
            name="permission_name"
            value={formData.permission_name}
            onChange={handleChange}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Description</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm"
          ></textarea>
        </div>
        <div className="flex justify-end space-x-2">
          <button
            type="button"
            onClick={() => navigate("/permissions")}
            className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
          >
            Back
          </button>
          <button type="submit" className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
            Save Changes
          </button>
        </div>
      </form>
    </div>
  );
};

export default UserPermissionEditPage;